module.exports = __webpack_public_path__ + "media/images/icon_x42-687f118758fb5af0f46a2a1b6b03224e.png";